import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import moment from "moment";


const Container = styled.div`
  width: 100%;
  margin-block: 10px;
  background-color: ${({ theme }) => theme.secondaryBgColor};
  cursor: pointer;
  .container {
    width: 100%;

    .content {
      width: 100%;
      padding: 15px 10px;
      border-radius: 10px;
      margin: 10px 0px 0px 0px !important;
      position: relative;
      background-color: var(--color-light);
      .row {
        width: 100%;
        display: grid;
        grid-template-columns:  repeat(9, 1fr);
        align-items: center;
        justify-content: center;
        min-height: 40px;
        .col {
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-sm);
          text-align: center;
          display: flex;
          flex-direction: column;
        }
      }
      .more{
        position: absolute;
        right: 10px;
        cursor: pointer;
        font-size: 20px;
      }
      .detail{
        position: absolute;
        top: 10px;
        right: 40px;
        background-color: white;
        padding: 10px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        gap: 5px;
        cursor: pointer;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        color: var(--color-main);
        
      }
    }
  }
`;

const IsArayanSurucuContainer = ({ data }) => {
  const { theme } = useSelector((state) => state.layout);

  return (
    <Container theme={theme}>
      <div className="container">
        <div className="content">
          <div className="row">
            <div className="col">{moment(data?.createdAt).format("DD.MM.YYYY")}</div>
            <div className="col">{data?.firstLastName}</div>
            <div className="col">{data?.contactNumber}</div>
            <div className="col">{data?.ehliyetTurleri?.b && "B "}{data?.ehliyetTurleri?.b && "B "}{data?.ehliyetTurleri?.be && "BE "}{data?.ehliyetTurleri?.c && "C "}{data?.ehliyetTurleri?.c1 && "C1 "}{data?.ehliyetTurleri?.ce && "CE "}{data?.ehliyetTurleri?.d && "D "}{data?.ehliyetTurleri?.de && "DE "}{data?.ehliyetTurleri?.g && "G"}</div>
            <div className="col">{data?.srcBelgeleri?.src1 && "SRC1 "}{data?.srcBelgeleri?.src2 && "SRC2 "}{data?.srcBelgeleri?.src3 && "SRC3 "}{data?.srcBelgeleri?.src4 && "SRC4 "}{data?.srcBelgeleri?.src5 && "SRC5"}</div>
            <div className="col">
            {data?.driverJobSeekerWorkCities?.$values?.map((item, index) => (
              <span key={index}>{item.city} </span>
            ))}
            </div>
            <div className="col">{data?.salary}</div>
            <div className="col">{data?.heavyVehicleExperience}</div>
            <div className="col">{data?.description}</div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default IsArayanSurucuContainer;
